import { createFileRoute, useParams } from "@tanstack/react-router";
import { ProjectPage } from "../components/projects/ProjectPage";
import { ReleasePage } from "../components/releases/ReleasePage";

/** A release's page (BUILD_SPEC §14.2, §16.4). */
function Page() {
  const { projectKey, releaseId } = useParams({ from: "/admin/p/$projectKey/releases/$releaseId" });
  return (
    <ProjectPage projectKey={projectKey}>
      {(project, canManage) => <ReleasePage project={project} releaseId={releaseId} canManage={canManage} />}
    </ProjectPage>
  );
}

export const Route = createFileRoute("/admin/p/$projectKey/releases/$releaseId")({ component: Page });
